import { useRef } from 'react';

import { HttpClientRequestConfig } from '../types';

export const useApiConfig = (httpClientRequestConfig: HttpClientRequestConfig = {}) => {
  const {
    current: config,
  } = useRef(httpClientRequestConfig);
  return config;
};
